import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Top 30 clientes (Valor gasto em compras)")
  ])
], -1)
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25 mt-10" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " Nome "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Telefone "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase text-center fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0"
    }, " Valor total ")
  ])
], -1)
const _hoisted_7 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "shadow-none text-center lh-1 fw-medium text-black-emphasis" }
const _hoisted_13 = { class: "d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mt-20" }
const _hoisted_14 = { class: "fs-14 text-muted mb-10 mb-sm-0" }
const _hoisted_15 = { "aria-label": "Paginação do ranking de clientes por valor gasto em compras" }
const _hoisted_16 = { class: "pagination mb-0" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getClientsRankingTotalValueSold, (value, key) => {
              return (_openBlock(), _createElementBlock("tr", { key: key }, [
                _createElementVNode("th", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(value.name != '' && value.name != null  ? value.name : 'Sem nome'), 1)
                  ])
                ]),
                _createElementVNode("td", _hoisted_10, [
                  _createElementVNode("a", {
                    href: `https://wa.me/55${value.phone}`,
                    target: "_blank",
                    class: "text-decoration-none"
                  }, _toDisplayString(value.phone), 9, _hoisted_11)
                ]),
                _createElementVNode("td", _hoisted_12, " R$ " + _toDisplayString(value.amount_sold), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, " Página " + _toDisplayString(_ctx.currentPage) + " de " + _toDisplayString(_ctx.getClientsRankingTotalValueSoldPagination.last_page || 1) + " — Total de " + _toDisplayString(_ctx.getClientsRankingTotalValueSoldPagination.total || _ctx.getClientsRankingTotalValueSold.length) + " clientes ", 1),
        _createElementVNode("nav", _hoisted_15, [
          _createElementVNode("ul", _hoisted_16, [
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", { disabled: _ctx.currentPage <= 1 }])
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "page-link",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPage(_ctx.currentPage - 1))),
                disabled: _ctx.currentPage <= 1
              }, " Anterior ", 8, _hoisted_17)
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", { disabled: _ctx.currentPage >= _ctx.getClientsRankingTotalValueSoldPagination.last_page }])
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "page-link",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage(_ctx.currentPage + 1))),
                disabled: _ctx.currentPage >= _ctx.getClientsRankingTotalValueSoldPagination.last_page
              }, " Próxima ", 8, _hoisted_18)
            ], 2)
          ])
        ])
      ])
    ])
  ]))
}